export default {"src":"/_next/static/media/sun_40.b0667362.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};